/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Venue } from '@app/settings/venues/venue.model';
import { VenuesSeoFormComponent } from '@app/settings/venues/venues-seo-form/venues-seo-form.component';

@Injectable({
  providedIn: 'root',
})
export class VenuesSeoFormService {
  constructor(private modalService: NgbModal) {}

  public open(venue: null | Venue = null): Promise<any> {
    const modal = this.modalService.open(VenuesSeoFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.venueSeo = venue;
    return modal.result;
  }
}
